import withOpenMaps from '@main/components/withOpenMaps'

const LocationMap = withOpenMaps(
  ({ profile, MapContainer, Marker, Popup, TileLayer }) => {
    if (!profile.latitude || !profile.longitude) {
      return null
    }

    const position = [parseFloat(profile.latitude), parseFloat(profile.longitude)]
    const zoom = 14

    return (
      <div>
        <MapContainer center={position} zoom={zoom}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              <div style={{ display: 'inline-block' }}>
                <b>{profile.name}</b>
                <br />
                {profile.address} <br />
                {profile.city}, {profile.state} {profile.zipCode}
              </div>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    )
  }
)

export { LocationMap }
